export default __webpack_public_path__ + "static/media/IS.7997a35b.ico";